// Mainpage.jsx
import React from "react";
import Header from "../components/Header";
import Body from "../components/Body";
import Footer from "../components/Footer";

const Mainpage = () => {
  return (
    <div>
      <main>
        {/* <h1 className="text-3xl font-bold">Contenido Principal de la Página</h1> */}
        <Header />
        <Body />
        <Footer />
      </main>
    </div>
  );
};

export default Mainpage;
